import { Country } from '@src/global/types/types';

export const sortCountriesAlphabetically = (
  countries: Country[]
): Country[] => {
  return [...countries].sort((a, b) => {
    return a.name.localeCompare(b.name);
  });
};
